import CustomerId from "../../state/CustomerId";
import FormId from "../../state/FormId";
import type { Token, TokenDto } from "../../services/ApiService";

export const toToken = ({ customerId, formId, token }: TokenDto): Token => ({
  customerId: CustomerId.from(customerId.toString()),
  formId: FormId.from(formId),
  token,
});
